import { Stack } from 'expo-router';
import { useAtomValue } from 'jotai';
import React from 'react';
import { XStack } from 'smoothie';

import { GroveLogo } from '../../common/components/GroveLogo';
import {
    adminUserAtom,
    selectedMembershipAtom,
} from '../../entities/entityAtoms';
import { RetirementCalculator } from './RetirementCalculator';

const RetirementCalculatorPage = () => {
    const adminUser = useAtomValue(adminUserAtom);
    const canAccessRetirementCalculator =
        adminUser.authorization.selectedMembership.accounts.canEdit;
    const selectedMembership = useAtomValue(selectedMembershipAtom);

    if (selectedMembership == null) {
        return null;
    }

    if (!canAccessRetirementCalculator) {
        return null;
    }

    return (
        <>
            <Stack.Screen
                options={{
                    headerLeft: () => (
                        <XStack marginHorizontal={16}>
                            <GroveLogo />
                        </XStack>
                    ),
                    headerTitle: 'Retirement Calculator',
                    headerTitleAlign: 'center',
                    headerBackVisible: true,
                }}
            />
            <RetirementCalculator />
        </>
    );
};

export default RetirementCalculatorPage;
